import { IconType } from "./icons.types";

export const VoucherIcon = ({ className, color = "#000000" }: IconType) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.66675 14.1667C1.66675 16.0076 3.15913 17.5 5.00008 17.5H15.0001C16.841 17.5 18.3334 16.0076 18.3334 14.1667V13.3333C18.3334 12.8731 17.9501 12.5136 17.5152 12.363C16.5363 12.0241 15.8334 11.0941 15.8334 10C15.8334 8.90585 16.5363 7.97588 17.5152 7.63698C17.9501 7.4864 18.3334 7.1269 18.3334 6.66667V5.83333C18.3334 3.99238 16.841 2.5 15.0001 2.5H5.00008C3.15913 2.5 1.66675 3.99238 1.66675 5.83333V6.66667C1.66675 7.1269 2.05008 7.4864 2.48499 7.63698C3.46386 7.97588 4.16675 8.90585 4.16675 10C4.16675 11.0941 3.46386 12.0241 2.48499 12.363C2.05008 12.5136 1.66675 12.8731 1.66675 13.3333V14.1667Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33341 7.50033C8.33341 7.96056 7.96032 8.33366 7.50008 8.33366C7.03984 8.33366 6.66675 7.96056 6.66675 7.50033C6.66675 7.04009 7.03984 6.66699 7.50008 6.66699C7.96032 6.66699 8.33341 7.04009 8.33341 7.50033Z"
        fill={color}
      />
      <path
        d="M13.3334 12.5003C13.3334 12.9606 12.9603 13.3337 12.5001 13.3337C12.0398 13.3337 11.6667 12.9606 11.6667 12.5003C11.6667 12.0401 12.0398 11.667 12.5001 11.667C12.9603 11.667 13.3334 12.0401 13.3334 12.5003Z"
        fill={color}
      />
      <path
        d="M12.5 7.5L7.5 12.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
